import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { convertUnit, airRoundOff, getAirUnit } from '../../../../utils/utility';
import { useMobileStyles } from '../styles';
import Icon from '../../../../utils/icons';
import I18n from '../../../../localization';
import { MODES } from '../../../../utils/constant';

export default function ScheduleScenes({ presets, isDarkMode, onSceneClick }) {
  const classes = useMobileStyles();

  const formatTemperature = (temp) => {
    if (temp === null || temp === undefined) {
      return '-';
    }
    // API gives Celsius, convert to Fahrenheit if needed
    const convertedTemp = airRoundOff(convertUnit(temp));
    return `${convertedTemp}`;
  };

  const getSceneTemperatureDisplay = (preset) => {
    const tempMode = preset['temperature-mode'] || MODES.AUTO;

    if (tempMode === MODES.OFF) {
      return '-';
    }

    const unit = getAirUnit() === 'C' ? '°C' : '°F';

    if (tempMode === MODES.HEAT) {
      return `${formatTemperature(preset['heat-setpoint'])}${unit}`;
    }

    if (tempMode === MODES.COOL) {
      return `${formatTemperature(preset['cool-setpoint'])}${unit}`;
    }

    return `${formatTemperature(preset['heat-setpoint'])}°-${formatTemperature(preset['cool-setpoint'])}${unit}`;
  };

  const getSceneTempModeIcon = (preset, isDarkMode) => {
    const tempMode = preset['temperature-mode'] || MODES.AUTO;
    return `${tempMode.toLowerCase()}Enabled`;
  };

  const getSceneFanModeIcon = (preset, isDarkMode) => {
  const fanMode = preset?.['fan-mode'] || MODES.AUTO;
  const mode = fanMode.toLowerCase();

  if (fanMode === MODES.AUTO) {
    return isDarkMode ? 'auto' : 'fanAutoEnabled';
  }

  if (fanMode === MODES.CIRCULATE) {
    return isDarkMode ? 'darkcirculateEnabled' : 'darkcirculate';
  }

  if (fanMode === MODES.ON) {
    return `${mode}Enabled`;
  }

  return `dark${mode}Enabled`;
};

  if (!presets || presets.length === 0) {
    return (
      <Box className={classes.scheduleScenesContainer}>
        <Typography className={classes.noScenesText}>
          {I18n.t('mobile.iqAirSetting.noScenesAvailable')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.scheduleScenesContainer}>
      <Typography className={classes.scenesSectionTitle}>
        {I18n.t('mobile.iqAirSetting.scenes')}
      </Typography>
      
      <Box className={classes.scenesGrid}>
        {presets.map((preset) => (
          <Box 
            key={preset['preset-id']} 
            className={`${classes.sceneCard} ${classes.addPointer}`}
            style={{
              boxShadow: `0 4px 0 0 ${isDarkMode ? preset['dark-color-code'] : preset['light-color-code']} inset`
            }}
            onClick={() => onSceneClick && onSceneClick(preset)}
          >
            <Box className={classes.sceneContent}>
              <Box className={classes.sceneTextIconPair}>
                <Typography className={classes.sceneName}>
                  {preset.name}
                </Typography>
                <Typography className={classes.sceneTemperature}>
                  {getSceneTemperatureDisplay(preset)}
                </Typography>
                
              </Box>
              <Box className={classes.sceneTextIconPair}>
                <Box className={classes.sceneIcon}>
                  <Icon 
                    src={getSceneTempModeIcon(preset, isDarkMode)} 
                    width="12px" 
                    height="12px"
                  />
                </Box>
                <Box className={classes.sceneIcon}>
                  <Icon 
                    src={getSceneFanModeIcon(preset, isDarkMode)} 
                    width="12px" 
                    height="12px"
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
